module.exports = __webpack_public_path__ + "static/media/ins1.1186af68.jpg";